/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".tot[_ngcontent-%COMP%]{font-weight:700;color:red}.train-name-container[_ngcontent-%COMP%]   .train-icon[_ngcontent-%COMP%]{height:14px}"];
export { styles as styles };
